import { useCallback, useContext, useEffect, useId } from 'react'
import { useNavigate } from 'react-router-dom'
import { DashboardContext } from '../../context'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { URLQUERY } from '../../config'
import { UserNotification } from '../../types'
import { Typography } from '@mui/material'
import util from '../../helpers/util.helper'

export default function NotificationCard({ body, date, id, status, origin, icon }: UserNotification) {
    const notifHtmlId = useId()
    const navigate = useNavigate()
    const dashboardContext = useContext(DashboardContext)
    const menuData = dashboardContext?.appData['menu']

    useEffect(() => {
        let aTarget = document.getElementById(notifHtmlId)
        aTarget?.querySelectorAll('a').forEach((el) => {
            el.href = `${el.href}${el.href.includes('?') ? '&' : '?'}${URLQUERY.readId}=${id}`
            el.addEventListener('click', (e) => {
                e.preventDefault()
                let host = window.location.origin
                navigate(el.href.replace(host, ''))
            })
        });
    }, [])
    return <div className={`notification ${status === 1 && 'readed'}`}>
        <div className='notification-icon'>
            <FontAwesomeIcon icon={icon} className='m-auto' />
        </div>
        <div className='w-100' id={notifHtmlId} dangerouslySetInnerHTML={{ __html: body }} />
        <div className='notification-data'>
            <Typography component='div' className='notification-info' variant='caption'>
                <FontAwesomeIcon icon={'calendar-alt'} className='m-auto' /> {util.setDateFormat(new Date(date), 'DD/MM/YYYY HH24:MI')}
            </Typography>
            <Typography component='div' className='notification-info' variant='caption'>
                <FontAwesomeIcon icon={'user'} className='m-auto' /> {origin}
            </Typography>
        </div>
    </div>
}
